import { clientAPIPrefetch } from './client-prefetch.js';

var prefetchObject = (window.__prefetch__ || {});
/**
 * 获取前端预请求数据
 * @param hash
 * @returns
 */
var getFrontPrefetch = function (options) {
    var prefetchResults = prefetchObject.prefetchResults, sendXHR = prefetchObject.sendXHR;
    // 获取预请求结果
    var result = prefetchResults[options.__hash__];
    if (result) {
        // 第一次访问走prefetch结果
        return result;
    }
    return sendXHR(options);
};
/**
 * 获取客户端预请求数据
 * @param options 请求参数
 * @returns
 */
var getClientPrefetch = function (options) {
    var startTime = performance.now();
    var startTimestamp = Date.now();
    return clientAPIPrefetch({
        timeout: options.timeout || 30000,
    })
        .then(function (response) {
        var endTime = performance.now();
        var endTimestamp = Date.now();
        return {
            data: response,
            status: 200,
            statusText: 'OK',
            config: options,
            request: options,
            prefetchType: 'client',
            timing: {
                startTime: startTime,
                endTime: endTime,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp,
                duration: endTime - startTime,
            },
        };
    })
        .catch(function (error) {
        var endTime = performance.now();
        var endTimestamp = Date.now();
        var PrefetchError = window.__prefetch__.PrefetchError;
        return Promise.reject(new PrefetchError(error.message, error.message, {
            data: error,
            status: error.result,
            statusText: error.message,
            config: options,
            request: options,
            prefetchType: 'client',
            timing: {
                startTime: startTime,
                endTime: endTime,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp,
                duration: endTime - startTime,
            },
        }));
    });
};
/**
 * 上报api埋点到雷达api表
 * api文档地址：https://docs.corp.kuaishou.com/d/home/fcAA3ZA6LSVZAtsNCFACFfXiu#
 */
var radarApiCollectHandle = function (response, extra) {
    var _a, _b, _c;
    var radarCore = window.__prefetch__.radarCore;
    (_a = radarCore === null || radarCore === void 0 ? void 0 : radarCore.collect) === null || _a === void 0 ? void 0 : _a.call(radarCore, 'api', {
        // response info
        res_type: 'xmlhttprequest',
        custom_failed: false,
        api: response.config.url,
        status: response.status,
        method: response.config.method || 'get',
        response_msg: (_b = response.data) === null || _b === void 0 ? void 0 : _b.message,
        response_code: (_c = response.data) === null || _c === void 0 ? void 0 : _c.result,
        //
        sample_rate: 1,
        is_official: -1,
        c_dimension1: response.prefetchType,
    }, {
        // duration浮点数落库会有问题
        duration: Number(response.timing.duration.toFixed(0)),
        // total为用户实际等待时间
        total: extra.duration,
        // 接口请求开始的时间
        fetch_start: Number(response.timing.startTime.toFixed(0)),
        // 接口请求结束的时间
        ttfb: Number(response.timing.endTime.toFixed(0)),
    });
};
/**
 * 上报api埋点到雷达api表
 * api文档地址：https://docs.corp.kuaishou.com/d/home/fcAA3ZA6LSVZAtsNCFACFfXiu#
 */
var radarApiCollectHandleError = function (error, extra) {
    var _a;
    var radarCore = window.__prefetch__.radarCore;
    var response = error.response;
    (_a = radarCore === null || radarCore === void 0 ? void 0 : radarCore.collect) === null || _a === void 0 ? void 0 : _a.call(radarCore, 'api', {
        // response info
        res_type: 'xmlhttprequest',
        custom_failed: false,
        api: response.config.url,
        status: response.status,
        method: response.config.method || 'get',
        response_msg: response.statusText,
        //
        sample_rate: 1,
        is_official: -1,
        c_dimension1: response.prefetchType,
    }, {
        // duration浮点数落库会有问题
        duration: Number(response.timing.duration.toFixed(0)),
        // total为用户实际等待时间 wait_duration
        total: extra.duration,
        // 接口请求开始的时间
        fetch_start: Number(response.timing.startTime.toFixed(0)),
        // 接口请求结束的时间
        ttfb: Number(response.timing.endTime.toFixed(0)),
    });
};
/**
 * 请求接口，存在客户端
 * @param prefetchOptions
 * @returns
 */
function prefetch(prefetchOptions) {
    var startTime = Date.now();
    var globalConf = window.__prefetch__ || {
        prefetchConfigs: {},
        prefetchCache: {},
        prefetchResults: {},
        isClientPrefetch: function () { return false; },
        isFrontendPrefetch: function () { return false; },
        getQuery: function () { return null; },
        getCookie: function () { return null; },
    };
    // 请求参数
    var options = prefetchOptions(globalConf);
    var hash = options.__hash__;
    var prefetchCache = globalConf.prefetchCache, isClientPrefetch = globalConf.isClientPrefetch, isFrontendPrefetch = globalConf.isFrontendPrefetch, sendXHR = globalConf.sendXHR;
    // 是否为首次请求
    var isFirstFetch = !prefetchCache[hash];
    var response;
    // 是否为首次请求
    if (isFirstFetch) {
        // 标记状态
        prefetchCache[hash] = true;
        if (isClientPrefetch(options)) {
            response = getClientPrefetch(options);
            // 前端接口预请求上报
            return response
                .then(function (response) {
                var endTime = Date.now();
                radarApiCollectHandle(response, { duration: endTime - startTime });
                return response;
            })
                .catch(function (error) {
                var endTime = Date.now();
                radarApiCollectHandleError(error, { duration: endTime - startTime });
                // return Promise.reject(error);
                // 超时兜底处理，超时时间改为5秒
                return sendXHR(options);
            });
        }
        if (isFrontendPrefetch(options)) {
            response = getFrontPrefetch(options);
            // 客户端接口预请求上报
            return response
                .then(function (response) {
                var endTime = Date.now();
                radarApiCollectHandle(response, { duration: endTime - startTime });
                return response;
            })
                .catch(function (error) {
                var endTime = Date.now();
                radarApiCollectHandleError(error, { duration: endTime - startTime });
                return Promise.reject(error);
            });
        }
        console.warn('[prefetch] 即为未命中“前端预请求”又未命中“客户端预请求”，将会直接发送xhr请求，请确认配置是否有问题...', options);
        // 非预请求的数据不上报
        return sendXHR(options);
    }
    // 非预请求的数据不上报
    return sendXHR(options);
}
function init(params) {
    if (window.__prefetch__) {
        window.__prefetch__.radarCore = params.radarCore;
    }
}

export { prefetch as default, init, prefetch };
//# sourceMappingURL=index.js.map
